/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

import { RECEIVED_REQUIRED_MINIMUM_DISTRIBUTION_SUMMARY } from 'state/distribution/RequiredMinimumDistributionSummaryActions';

export const requiredMinimumDistributionSummaryReducer = (state = {}, action) => {
  if (action.type === RECEIVED_REQUIRED_MINIMUM_DISTRIBUTION_SUMMARY) {
    return action.requiredMinimumDistributionSummary;
  }

  return state;
};
